export { MAX_FILE_BYTES } from '@/lib/file-upload';

export const PAGE_SIZE = 10;

export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'resolved', label: 'Resolved' },
] as const;
